import { Map, Record } from "immutable";

import { Content, Contents } from "./contents/Contents";
import Course from "./courses/course/Course";
import { Courses } from "./courses/Courses";
import CoursesMeta from "./courses/meta";
import { ContentModule, Modules } from "./modules/Modules";
import { Section, Sections } from "./sections/Sections";
import { Word, Words } from "./words/Words";

export type CoursesStateSliceType = {
  courses: Courses;
  sections: Sections;
  contents: Contents;
  modules: Modules;
  words: Words;
  meta: CoursesMeta;
};

export type OptionalCoursesStateSliceType = Partial<CoursesStateSliceType>;

const coursesStateSlice: CoursesStateSliceType = {
  courses: Map<string, Course>(),
  sections: Map<string, Section>(),
  contents: Map<string, Content>(),
  modules: Map<string, ContentModule>(),
  words: Map<string, Word>(),
  meta: new CoursesMeta()
};

export default class CoursesStateSlice extends Record(coursesStateSlice) {}
